module.exports = __webpack_public_path__ + "img/page_loading.c4e9a077.gif";